<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t2">Adventures with Canine Cupids Box Set</span></p>
<p class="p0">By Deirdre O’Dare</p>
<p class="p2"><a id="a3"></a><a href="#/004#a29">Doggone Love</a></p>
<p class="p2"><span href="#/005#a30" title="Link target outside of Sample">The Maltese Terror</span></p>
<p class="p4"><span href="#/005#a31" title="Link target outside of Sample">Chapter 1</span></p>
<p class="p4"><span href="#/006#a32" title="Link target outside of Sample">Chapter 2</span></p>
<p class="p4"><span href="#/007#a33" title="Link target outside of Sample">Chapter 3</span></p>
<p class="p4"><span href="#/008#a34" title="Link target outside of Sample">Chapter 4</span></p>
<p class="p4"><span href="#/009#a35" title="Link target outside of Sample">Chapter 5</span></p>
<p class="p4"><span href="#/010#a36" title="Link target outside of Sample">Chapter 6</span></p>
<p class="p2"><span href="#/011#a37" title="Link target outside of Sample">A New Leash on Life</span></p>
<p class="p4"><span href="#/011#a38" title="Link target outside of Sample">Chapter 1</span></p>
<p class="p4"><span href="#/012#a39" title="Link target outside of Sample">Chapter 2</span></p>
<p class="p4"><span href="#/013#a40" title="Link target outside of Sample">Chapter 3</span></p>
<p class="p4"><span href="#/014#a41" title="Link target outside of Sample">Chapter 4</span></p>
<p class="p4"><span href="#/015#a42" title="Link target outside of Sample">Chapter 5</span></p>
<p class="p4"><span href="#/016#a43" title="Link target outside of Sample">Chapter 6</span></p>
<p class="p4"><span href="#/017#a44" title="Link target outside of Sample">Chapter 7</span></p>
<p class="p2"><span href="#/018#a45" title="Link target outside of Sample">Love Is Snowblind</span></p>
<p class="p4"><span href="#/018#a46" title="Link target outside of Sample">Chapter 1</span></p>
<p class="p4"><span href="#/019#a47" title="Link target outside of Sample">Chapter 2</span></p>
<p class="p4"><span href="#/020#a48" title="Link target outside of Sample">Chapter 3</span></p>
<p class="p4"><span href="#/021#a49" title="Link target outside of Sample">Chapter 4</span></p>
<p class="p4"><span href="#/022#a50" title="Link target outside of Sample">Chapter 5</span></p>
<p class="p4"><span href="#/023#a51" title="Link target outside of Sample">Chapter 6</span></p>
<p class="p4"><span href="#/024#a52" title="Link target outside of Sample">Chapter 7</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?8394511e